module.exports = __webpack_public_path__ + "img/tech-16.343c7e85.jpg";